<template>
  <HeaderBar />

  <ButtonBackContainer>
    <ButtonBack :fallback="{ name: 'receivables', query: { tab: 'problems' } }">{{
      t('back')
    }}</ButtonBack>
  </ButtonBackContainer>

  <section class="carvia-container">
    <div v-if="payment" class="rounded-lg bg-white p-4">
      <PaymentDetailsContent :payment="payment" allocate-across-bookings />
    </div>
    <div v-else-if="isError" class="rounded-lg bg-white p-4">{{ t('notFound') }}</div>
    <div v-else class="flex justify-center"><Spinner /></div>
  </section>
</template>

<script lang="ts" setup>
import ButtonBack from '@/components/buttons/ButtonBack.vue';
import ButtonBackContainer from '@/components/ButtonBackContainer.vue';
import HeaderBar from '@/components/headerbar/HeaderBar.vue';
import Spinner from '@/components/icons/Spinner.vue';
import PaymentDetailsContent from '@/components/booking-forms/PaymentDetailsContent.vue';
import { formatDate } from '@/hooks/use-formatted-date';
import { formatCurrency } from '@/utils/format-numbers';
import { usePayment } from '@/queries/use-payments';
import { useUiStore } from '@/stores/ui.store';
import { DateTime } from 'luxon';
import { computed, watchEffect } from 'vue';
import { useI18n } from 'vue-i18n';
import { useRoute } from 'vue-router';

const { t } = useI18n();
const uiStore = useUiStore();
const route = useRoute();
const paymentId = computed(() => route.params.id as string);

const { data: payment, isError } = usePayment(paymentId);

watchEffect(() => {
  if (payment.value) {
    uiStore.setHeaderTitle(
      t('payment'),
      formatCurrency(payment.value.amount),
      formatDate(payment.value.date, DateTime.DATE_MED),
    );
  } else {
    uiStore.setHeaderTitle(t('payment'));
  }
});
</script>

<i18n lang="json">
{
  "en": {
    "back": "Back",
    "payment": "Payment",
    "notFound": "Payment not found"
  },
  "de": {
    "back": "Zurück",
    "payment": "Zahlung",
    "notFound": "Zahlung nicht gefunden"
  },
  "es": {
    "back": "Volver",
    "payment": "Pago",
    "notFound": "Pago no encontrado"
  }
}
</i18n>
